import { render, staticRenderFns } from "./OnDemandLevel.vue?vue&type=template&id=00a222eb&scoped=true"
import script from "./OnDemandLevel.vue?vue&type=script&lang=js"
export * from "./OnDemandLevel.vue?vue&type=script&lang=js"
import style0 from "./OnDemandLevel.vue?vue&type=style&index=0&id=00a222eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a222eb",
  null
  
)

export default component.exports